import React from "react"
import {RadioItem} from "./radioItem"
export const radioList = [
    {title:'Place'},
    {title:'Office'},
    {title:'Coffê'},
    {title:'Shop'},
] 


export const Radios = ({data=radioList}) => {

    return (<div className="radios">
        <h4>Type</h4>
        <ul>
            {
                data.map((item,i)=>{
                    return (
                       <RadioItem item={item} index={i} key={'radio-list'+i} />
                    )
                })
            }
        </ul>
    </div>)

}
